import { combineReducers } from 'redux';
import { byIdReducerTemplate } from '../reducerUtils';
import { hasIn } from 'lodash';

function allIdsReducer(state = [], action) {
  if (hasIn(action, ['normalizedData', 'entities', 'matrixQuestions'])) {
    return state.concat(
      Object.keys(action.normalizedData.entities.matrixQuestions)
    );
  } else {
    return state;
  }
}

export default combineReducers({
  byId: byIdReducerTemplate('matrixQuestions'),
  allids: allIdsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/matrixQuestionsReducer.js